import React from "react";
import { useTranslation } from "react-i18next";
import DynamicProductComparison from "./ProductComparison";
import { kidWatchesData } from "./deta-ProductComparison/kidWatchesData";
import { kidWatchTranslations } from "./deta-ProductComparison/kidWatchTranslations";

const KidWatchComparison: React.FC = () => {
    const { i18n } = useTranslation();
    const lang = (i18n.language || "fa").split("-")[0];
    const langKey = (["fa", "en", "ar", "tr"].includes(lang) ? lang : "fa") as keyof typeof kidWatchTranslations;
    const t = kidWatchTranslations[langKey] || kidWatchTranslations.fa;

    return (
        <DynamicProductComparison
            title={t.title}
            subtitle={t.subtitle}
            description={t.description}
            data={kidWatchesData}
            defaultCategory="all"
            showCategories={false}
        />
    );
};

export default KidWatchComparison;
